export enum CalculationStatusEnum {
  CREATED = "CREATED",
  DONE = "DONE",
}
